import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const CheckCircleIcon = (props?: SvgProps) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM43.9016 25.1516C45.3661 23.6872 45.3661 21.3128 43.9016 19.8484C42.4372 18.3839 40.0628 18.3839 38.5984 19.8484L26.25 32.1967L21.4016 27.3483C19.9372 25.8839 17.5628 25.8839 16.0984 27.3483C14.6339 28.8128 14.6339 31.1872 16.0984 32.6516L23.5984 40.1516C25.0628 41.6161 27.4372 41.6161 28.9016 40.1516L43.9016 25.1516Z"
        fill="#22C55E"
      />
    </svg>
  )
}
